module.exports = __webpack_public_path__ + "img/stone-furnace.565dfa0d.png";